<template>
  <div>
    <div class="window"></div>
    <div class="onWindow">
      <div class="landscape">
        <AmazingShit></AmazingShit>
        <p class="text">
          To this day that part of the ship remains crypted, sorry try again in
          a few months.. <br />
          (that shit looks dope here's
          <a href="https://juliangarnier.com/" target="_blank">the guy </a>who
          did it)
        </p>
        <Portal></Portal>
      </div>
      <div class="portrait">
        <NotOriented></NotOriented>
      </div>
    </div>
  </div>
</template>

<script>
import Portal from "./Portal";
import MainMixin from "@/components/utilities/MainMixin.vue";
import NotOriented from "@/components/mobile/NotOriented";
import AmazingShit from "@/components/utilities/AmazingShit";
export default {
  name: "Toilets",
  title: "Toilets",
  mixins: [MainMixin],
  components: {
    Portal,
    NotOriented,
    AmazingShit,
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.window {
  position: absolute;
  min-width: 101vw;
  min-height: 101vh;
  top: 0;
  left: -5;
  z-index: 1;
  opacity: 0.5;
  background-color: black;
}

.onWindow {
  position: relative;
  height: 100vh;
  z-index: 2;
}

.text {
  position: absolute;
  width: 100%;
  bottom: 15vh;
  text-align: center;
  z-index: 2;
}

@media (orientation: portrait) {
  .window {
    display: none;
    opacity: 0;
  }
}
</style>
